<div class="bet-limit-screen tw-mb-[32px]">
  <div class="bet-limit-checkbox">
    <span class="limit tw-capitalize tw-text-[16px] tw-text-[#0F2950]" slot="start">
      Bet Limit
    </span>
    <ion-checkbox
      mode="md"
      [value]="isWagerLimit"
      [disabled]="isProcessing"
      [checked]="isWagerLimit"
      (ionChange)="toggleCheckbox()"
      id="isWagerLimit"
      class="active-limit tw-float-right tw-top-1 tw-mt-0 tw-mb-0">
    </ion-checkbox>
  </div>
  <input
    amwager3DecimalInput
    [(ngModel)]="wagerLimit"
    (keyup)="onAmount($event)"
    [disabled]="activeBetLimit || isProcessing"
    [value]="wagerLimit"
    type="number"
    placeholder=""
    step="0.01" min="0" pattern="^\d+(\.\d{1,2})?$"
    class="
      tw-w-[100%]
      tw-h-[38px]
      tw-bg-[#E8E8E8]
      tw-text-[19px]
      tw-text-[#9A9A9A]
      tw-rounded-[6px]
      tw-py-[8px]
      tw-px-[9px]
      tw-mt-[5px]
    "
  >
  <div *ngIf="currentState === 'NY'" class="bet-limit-checkbox">
    <span class="limit tw-capitalize tw-text-[16px] tw-text-[#0F2950]" slot="start">
      Daily Loss Limit
    </span>
    <!-- <ion-checkbox
      mode="md"
      [value]="isWagerLimit"
      [disabled]="isProcessing"
      [checked]="isWagerLimit"
      (ionChange)="toggleCheckbox()"
      id="isWagerLimit"
      class="active-limit tw-float-right tw-top-1 tw-mt-0 tw-mb-0">
    </ion-checkbox> -->
  </div>
  <input
    *ngIf="currentState === 'NY'"
    amwager3DecimalInput
    [(ngModel)]="wagerDailyLossLimit"
    (keyup)="onDailyLossLimitAmount($event)"
    [disabled]="isProcessing"
    [value]="wagerDailyLossLimit"
    type="number"
    placeholder=""
    step="0.01" min="0" pattern="^\d+(\.\d{1,2})?$"
    class="
      tw-w-[100%]
      tw-h-[38px]
      tw-bg-[#E8E8E8]
      tw-text-[19px]
      tw-text-[#9A9A9A]
      tw-rounded-[6px]
      tw-py-[8px]
      tw-px-[9px]
      tw-mt-[5px]
    "
  >
  <p *ngIf="pendingLossLimitEffective && isTriggeredDailyLoss">
    New Limit of ${{pendingLossLimit}} will take effect on<br>
    {{pendingLossLimitEffective | dateFormat: 'MMMM DD, YYYY'}} date.
  </p>
</div>
